import React, { useContext, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Highlight from 'react-highlight';
import { AppSettings } from './../../config/app-settings.js';

function PageOptionShell({ title, description = 'page header description goes here...', code, content, children, headerTitle = 'Installation', cardClass = 'card card-borderless mb-3', breadcrumbClass = 'breadcrumb float-xl-end' }) {
	return (<>
		<ol className={breadcrumbClass}><li className="breadcrumb-item"><Link to="/">Home</Link></li><li className="breadcrumb-item"><Link to="/layout/starter">Layout</Link></li><li className="breadcrumb-item active">{title}</li></ol>
		<h1 className="page-header">{title} <small>{description}</small></h1>
		<div className={cardClass}><div className="card-header bg-gray-900"><h4 className="card-header-title text-white">{headerTitle}</h4><div className="card-header-btn"><a href="#/" className="btn btn-xs btn-icon btn-default" data-toggle="card-expand"><i className="fa fa-expand"></i></a><a href="#/" className="btn btn-xs btn-icon btn-success" data-toggle="card-reload"><i className="fa fa-redo"></i></a><a href="#/" className="btn btn-xs btn-icon btn-warning" data-toggle="card-collapse"><i className="fa fa-minus"></i></a><a href="#/" className="btn btn-xs btn-icon btn-danger" data-toggle="card-remove"><i className="fa fa-times"></i></a></div></div><div className="card-body">{content || children}</div>{code && <div className="hljs-container hljs-wrapper rounded-0 rounded-bottom" data-bs-theme="dark"><pre><Highlight className="html">{code}</Highlight></pre></div>}</div>
	</>);
}

function PageOptionDemo({ title, setting, settingValue = true, codePath, content, children, headerTitle, cardClass, breadcrumbClass }) {
	const context = useContext(AppSettings);
	const [code, setCode] = useState();
	useEffect(() => {
		const settings = Array.isArray(setting) ? setting : setting ? [setting] : [];
		settings.forEach((name) => context[name](settingValue));
		if (codePath) fetch(`/color-admin/admin/react/assets/data/${codePath}/code-1.json`).then((response) => response.text()).then(setCode);
		return () => settings.forEach((name) => context[name](name === 'handleSetAppClass' ? '' : false));
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);
	return <PageOptionShell title={title} code={code} content={content} headerTitle={headerTitle} cardClass={cardClass} breadcrumbClass={breadcrumbClass}>{children}</PageOptionShell>;
}

function PageFullWidth() {
	return (
		<PageOptionDemo
			title="Full Width"
			path="/layout/full-width"
			setting="handleSetAppSidebarNone"
			codePath="page-full-width"
			content={<p>Add the <code>.app-without-sidebar</code> element to <code>.app</code> container for without sidebar setting.</p>}
		/>
	);
}

export default PageFullWidth;
